const PREVIEW_HOSTNAME_PREFIX = 'preview.'

export {
  PREVIEW_HOSTNAME_PREFIX,
}
